import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { runStatusBadgeMessages, heartbeatStatusBadgeMessages } from '../dashboard/connectionMonitorPage/constants';
import { statusBadgeMessages } from './constants';

const lowercaseStatusBadgeMessages = Object.keys(statusBadgeMessages).reduce((acc, key) => ({
  ...acc,
  [key]: statusBadgeMessages[key].toLowerCase(),
}), {});

function StatusBadge({ className, value }) {
  const badgeMessages = {
    ...lowercaseStatusBadgeMessages,
    ...heartbeatStatusBadgeMessages,
    ...runStatusBadgeMessages,
  };

  const badgeClassNames = classnames(
    'badge', 'status-badge',
    {
      'badge-success': value
        && ([
          badgeMessages.CALCULATED,
          badgeMessages.PROCESSING_COMPLETE,
          badgeMessages.COMPLETE,
        ].includes(value.toLowerCase())
        || [
          badgeMessages.ON_SCHEDULE,
          badgeMessages.ACTIVE,
        ].includes(value)),
      'badge-info': value
        && [
          badgeMessages.IN_PROCESS,
          badgeMessages.PROCESSING,
        ].includes(value.toLowerCase()),
      'badge-secondary': value && value.toLowerCase() === badgeMessages.NOT_STARTED,
      'badge-warning': value && value.toLowerCase() === badgeMessages.PENDING,
      'badge-primary': value && value.toLowerCase() === badgeMessages.UPDATED,
      'badge-danger': value
        && ([
          badgeMessages.OVERDUE,
          badgeMessages.INACTIVE,
        ].includes(value)
        || value.toLowerCase() === badgeMessages.ERROR),
    },
    className
  );

  return (
    <span className={badgeClassNames}>
      {value}
    </span>
  );
}

StatusBadge.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
};

export default StatusBadge;
